module.exports = __webpack_public_path__ + "static/img/1公司介绍.96dab90.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/关于我们/1公司介绍.png
// module id = pRdT
// module chunks = 0